if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.stickyBar = this;
        this.mainProductForm = document.querySelector('.product-form');
        this.submitButton = this.mainProductForm.querySelector('button[type="submit"]');
        this.stickyProductForm = this.stickyBar.querySelector('.product-form');
        this.productJson = document.querySelector('product-info variant-selects script[type="application/json"]')?.textContent || null;
        this.isVisible = false;

        if (!this.stickyBar) return;

        this.init();
      }

      init() {
        this.setupScrollListener();
        this.setupFormSync();
      }

      setupScrollListener() {
        const mainButton = this.submitButton;
        if (!mainButton) return;

        const observerOptions = {
          root: null,
          threshold: 0.01
        };

        let hasPassedButton = false;

        const observerCallback = (entries) => {
          entries.forEach(entry => {
            if (!hasPassedButton) {
              if (entry.isIntersecting) {
                hasPassedButton = true;
                this.hideStickyBar();
              }
            } else {
              if (entry.isIntersecting && this.isVisible) {
                this.hideStickyBar();
              } else if (!entry.isIntersecting && !this.isVisible) {
                this.showStickyBar();
                const stickyBarHeight = this.stickyBar.offsetHeight;
                document.documentElement.style.setProperty('--sticky-bar-height', `${stickyBarHeight}px`);
              }
            }
          });
        };

        this._stickyBarObserver = new window.IntersectionObserver(observerCallback, observerOptions);
        this._stickyBarObserver.observe(mainButton);
      }

      setupFormSync() {
        if (!this.mainProductForm || !this.stickyProductForm) return;

        // Sync form data when main form changes
        this.mainProductForm.addEventListener('change', (e) => {
          if (e.target.name === 'id') {
            const stickyVariantInput = this.stickyProductForm.querySelector('input[name="id"]');
            if (stickyVariantInput) {
              stickyVariantInput.value = e.target.value;

              this.updatePrice(e.target.value);
            }
          }
        });

        // Sync form data when sticky form changes
        this.stickyProductForm.addEventListener('change', (e) => {
          if (e.target.name === 'id') {
            const mainVariantInput = this.mainProductForm.querySelector('input[name="id"]');
            if (mainVariantInput) {
              mainVariantInput.value = e.target.value;

              this.updatePrice(e.target.value);
            }
          }
        });
      }

      updatePrice(variantId) {
        if(!variantId) return;

        const variantIdNum = typeof variantId === 'string' ? parseInt(variantId, 10) : variantId;
        const variant = JSON.parse(this.productJson).find(v => v.id === variantIdNum);

        if (!variant) return;

        const formatMoney = (cents) => {
          return `$${(cents / 100).toFixed(2)}`;
        };

        const stickyPrice = this.stickyProductForm.querySelector('.price-item--regular');
        if (stickyPrice) {
          stickyPrice.textContent = formatMoney(variant.price);
        }

        const stickyComparePrice = this.stickyProductForm.querySelector('.price-item--sale');
        if (stickyComparePrice) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            stickyComparePrice.textContent = formatMoney(variant.compare_at_price);
            stickyComparePrice.style.display = '';
          } else {
            stickyComparePrice.style.display = 'none';
          }
        }
      }

      showStickyBar() {
        this.stickyBar.classList.add('is-visible');
        document.body.classList.add('sticky-bar-visible');
        this.isVisible = true;
      }

      hideStickyBar() {
        this.stickyBar.classList.remove('is-visible');
        document.body.classList.remove('sticky-bar-visible');
        this.isVisible = false;
      }
    }
  );
}